import { render, staticRenderFns } from "./KabPuncak.vue?vue&type=template&id=10529b96"
import script from "./KabPuncak.vue?vue&type=script&lang=js"
export * from "./KabPuncak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports